import styled from 'styled-components';

import { ACTIVITIES_BASE_HEIGHT_SMALL } from 'global/constants';
import { rem } from 'approot/shared/style';
import {
  getBackgroundColour,
  getBorderColour,
  getFieldHeight,
} from './response.utils';
import { grey1, grey5 } from 'approot/shared/styles/colours.style';
import { borderRadius8 } from 'approot/shared/styles/borders.style';
import {
  spacing12,
  spacing24,
  spacing8,
} from 'approot/shared/styles/spacing.style';
import { useActivityBuilderFontStyles } from 'approot/activity-builder/theme/activity-builder-theme.style';
import {
  richtextCommonCss,
  RichtextProps,
} from 'approot/shared/richtext/richtext.style';

type ResponseFieldReadonlyProps = {
  $numberOflines: number;
  $baseHeight?: number | null;
  $baseColour?: string | null;
} & RichtextProps;

export const ResponseFieldReadonly = styled.div.attrs<ResponseFieldReadonlyProps>(
  {
    $isSmall: true,
  }
)`
  ${() =>
    useActivityBuilderFontStyles({
      isSmall: true,
    })}

  border: 1px solid ${grey5};
  border-radius: ${rem(borderRadius8)};
  cursor: not-allowed;
  min-height: ${props =>
    rem(getFieldHeight(props.$numberOflines, props.$baseHeight) + 2)};
  width: 100%;

  ${({ $baseColour }) =>
    $baseColour
      ? `
      background-color: ${getBackgroundColour($baseColour)};
      border-color: ${getBorderColour($baseColour)};
    `
      : `
      background-color: ${grey1};
    `}

  ${({ $baseHeight }) =>
    $baseHeight === ACTIVITIES_BASE_HEIGHT_SMALL
      ? `
      padding: ${rem(spacing8)};
    `
      : `
      padding: ${rem(spacing8)} ${rem(spacing24)};
    `}

    ${({ $numberOflines }) =>
    $numberOflines === 1 &&
    `
        padding-top: ${rem(spacing12)};
      `};
  ${richtextCommonCss}
`;
